export default __webpack_public_path__ + "static/media/practice_top_bg.ae537385.png";